import {BasePaginatedListResponse, BasePaginationParams} from './Base';

export enum UserRole {
  SHOWROOM_MANAGER = 'SHOWROOM_MANAGER',
  SALES_MANAGER = 'SALES_MANAGER',
  RECEPTIONIST = 'RECEPTIONIST',
  READ_ONLY = 'READ_ONLY',
  SELLER = 'SELLER',
  BUYER = 'BUYER',
  STORE = 'STORE',
}

export interface User {
  user_role: UserRole;
  first_name: string;
  last_name: string;
  phone_number: string;
  versace_email: string;
  external_email: string;
  versace_manager: number;
  client_id: string;
  store_name: string;
  region?: string;
  stores?: Store[];
}

export interface Account {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  external_email: string;
  role: UserRole;
  client_id: number;
  store_name: string;
  phone_number: string;
  stores?: Store[];
}

export interface GetUserResponse {
  id: number;
  email: string;
  external_email: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  client_id: string;
  store_name: string;
  versace_manager: number;
  role: UserRole;
  stores?: Store[];
}

interface Store {
  id: number;
  store_name: string;
  client_id: string;
}

export interface Manager {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  external_email: string;
  role: UserRole;
  client_id: string;
  store_name: string;
  phone_number: string;
}

export interface GetManagersResponse extends Array<Manager> {}

export interface GetUsersParams extends BasePaginationParams {
  /** Filter users by role */
  roles?: UserRole[];
  /** Filter user by name */
  fullname?: string;

  search?: string;
}

export interface GetStoresParams extends BasePaginationParams {
  /** Filter user by name */
  search?: string;
}

export interface GetUsersResponse extends BasePaginatedListResponse<Account> {}
